/**
 * @file
 * Behaviors for the Card List.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Card List behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.pagehero = {
    attach: function() {
      // Coloring for CIO-SP4
      $(
        '.page-hero .has-sidebar .card__link--content:contains(\'CIO-SP4\')'
      ).html(function(_, html) {
        return html.replace(/(CIO-SP4)/g, '<span class="text-blue">$1</span>');
      });

      // Coloring for CIO-CS
      $('.page-hero .has-sidebar .card__link--content:contains(\'CIO-CS\')').html(
        function(_, html) {
          return html.replace(
            /(CIO-CS)/g,
            '<span class="text-green">$1</span>'
          );
        }
      );

      // Coloring for CIO-SP3 Small Business
      $(
        '.page-hero .has-sidebar .card__link--content:contains(\'CIO-SP3 Small Business\')'
      ).html(function(_, html) {
        return html.replace(
          /(CIO-SP3 Small Business)/g,
          '<span class="text-blue">$1</span>'
        );
      });

      // Coloring for CIO-SP3
      $(
        '.page-hero .has-sidebar .card__link--content:contains(\'CIO-SP3\')'
      ).html(function(_, html) {
        return html.replace(/(CIO-SP3)/g, '<span class="text-blue">$1</span>');
      });
    }
  };
})(Drupal, jQuery);
